<ng-container>
  <div class="sticky-header">
    <app-header></app-header>
  </div>
  <div class="container-fluid">
    <div class="row dashboard-midpart">
      <nav class="dashboardTabs">
        <div class="nav nav-tabs executor-nav-tabs" id="nav-tab" role="tablist" [ngClass]="isArabic ? 'arabicNav' : ''">
          <button class="nav-link" id="nav-execution-tab" type="button" role="tab"
            [ngClass]="tabId == 'execution' ? 'active' : ''" (click)="onListItemClick('execution')">
            <span *ngIf="!isArabic">Execution</span>
            <span *ngIf="isArabic">التنفيذ</span>
          </button>
          <button class="nav-link" id="nav-execution-tab" type="button" role="tab"
            [ngClass]="tabId == 'action-items' ? 'active' : ''" (click)="onListItemClick('action-items')">
            <span *ngIf="!isArabic">Action Plans</span>
            <span *ngIf="isArabic">خطط العمل التصحيحية</span>
          </button>
           <button class="nav-link" id="nav-execution-tab" type="button" role="tab"
            [ngClass]="tabId == 'enforcement' ? 'active' : ''" (click)="onListItemClick('enforcement')">
            <span *ngIf="!isArabic">Enforcement</span>
            <span *ngIf="isArabic">إجراءات الإنفاذ</span>
          </button>
           <button class="nav-link" id="nav-execution-tab" type="button" role="tab"
            [ngClass]="tabId == 'fines' ? 'active' : ''" (click)="onListItemClick('fines')">
            <span *ngIf="!isArabic">Fines</span>
            <span *ngIf="isArabic">الغرامات</span>
          </button>
           <button class="nav-link" id="nav-execution-tab" type="button" role="tab"
            [ngClass]="tabId == 'appeal' ? 'active' : ''" (click)="onListItemClick('appeal')">
            <span *ngIf="!isArabic">Appeal</span>
            <span *ngIf="isArabic">التظلّمات</span>
          </button>
          <!-- <button
            class="nav-link"
            id="nav-reporting-tab"
            
            type="button"
            role="tab"
            [ngClass]="tabId == 'reporting' ? 'active' : ''"
             (click)="onListItemClick('reporting')"
          >
          <span *ngIf="!isArabic">Reporting</span>
          <span *ngIf="isArabic">التقارير</span>
          </button> -->
          <button class="nav-link" id="nav-monitoring-tab" type="button" role="tab"
            [ngClass]="tabId == 'monitoring' ? 'active' : ''" (click)="onListItemClick('monitoring')" *ngIf="isChecker">
            <span *ngIf="!isArabic">Checker Review</span>
            <span *ngIf="isArabic">مراجعة المدقق</span>
          </button>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent" *ngIf="tabId == 'execution'">
        <app-execution [executionList]="executionList" [ifAssesment]="ifAssesment"
          [isResubmitRejectedAssessment]="isResubmitRejectedAssessment"
          [rejectedAssessmentsCount]="rejectedAssessmentsCount"></app-execution>
      </div>
      <div class="tab-content" id="nav-tabContent" *ngIf="tabId == 'enforcement'">
        <app-enforcement [enforcementList]="enforcementList"></app-enforcement>
      </div>
      <div class="tab-content" id="nav-tabContent" *ngIf="tabId == 'fines'">
        <app-fines [finesList]="finesList"></app-fines>
      </div>
      <div class="tab-content" id="nav-tabContent" *ngIf="tabId == 'appeal'">
        <app-appeal [appealList]="appealList"></app-appeal>
      </div>
      <div class="tab-content" id="nav-tabContent" *ngIf="tabId == 'reporting'">
        <app-reporting></app-reporting>
      </div>
      <div class="tab-content" id="nav-tabContent" *ngIf="tabId == 'action-items'">
        <app-action-items [actionItemsList]="actionItemsList" [ifPendingActionItem]="ifPendingActionItem"
          [ifRejectedActionItem]="ifRejectedActionItem"
          [ifHistoricalActionItem]="ifHistoricalActionItem"></app-action-items>
      </div>
      <div class="tab-content" id="nav-tabContent" *ngIf="tabId == 'monitoring'">
        <app-monitoring [monitoringList]="monitoringList" [ifReviewAssesment]="ifReviewAssesment"
          [ifResubmitAssesment]="isResubmitRejectedAssessmentForChecker">
        </app-monitoring>
      </div>
    </div>
  </div>
  <div class="footerDiv">
    <app-footer></app-footer>
  </div>
</ng-container>

<div class="custom-overlay" *ngIf="isFirstTime">
  <div class="custom-modal">
    <div class="modal-body text-center">
      <p *ngIf="!isArabic">Thank you for logging into the DIEZ Compliance portal. No action is required at this time.
      <br/>You will be notified, if any assessments are assigned to you.</p>
      <p *ngIf="isArabic">Thank you for logging into the DIEZ Compliance portal. No action is required at this time.
      <br/>You will be notified, if any assessments are assigned to you.</p>
      <button class="btn btn-primary" (click)="closePopup()">
        {{ isArabic ? 'إغلاق' : 'Close' }}
      </button>
    </div>
  </div>
</div>